module.exports = __webpack_public_path__ + "static/media/cross-device-mockup-4x3-mobile@0.5x.c252184d.png";